import { useState, useEffect, useRef } from "react";
import Fade from "react-reveal/Fade";

const Modal = ({ trigger, closeCallback, options, children }) => {
  const [mounted, setMounted] = useState(false);
  const [active, setActive] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (!mounted) setMounted(true);
    else setActive(!active);
  }, [trigger]);

  useEffect(() => {
    const details = modalRef.current?.querySelectorAll("details");
    // Add the onclick listeners.
    details.forEach((detail) => {
      detail.addEventListener("toggle", () => {
        if (detail.open) setTargetDetail(detail);
      });
    });

    function setTargetDetail(targetDetail) {
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.open = false;
        }
      });
    }
    return () => {
      details.forEach((detail) => {
        detail.removeEventListener("toggle", () => {
          if (detail.open) setTargetDetail(detail);
        });
      });
    };
  }, []);

  useEffect(() => {
    if (active) {
      // close modal if outside area is clicked
      const handleOutsideModalClick = (event) => {
        const modalOffsetLeft = modalRef?.current?.offsetParent?.offsetLeft;
        const modalOffsetTop = modalRef?.current?.offsetParent?.offsetTop;
        const modalOffsetParentWidth =
          modalRef?.current?.offsetParent?.offsetWidth;
        const modalOffsetParentHeight =
          modalRef?.current?.offsetParent?.offsetHeight;
        const modalBounds = [
          [modalOffsetLeft, modalOffsetTop],
          [
            modalOffsetLeft + modalOffsetParentWidth,
            modalOffsetTop + modalOffsetParentHeight,
          ],
        ];
        const mousePos = [event.clientX, event.clientY];
        if (
          mousePos[0] < modalBounds[0][0] ||
          mousePos[0] > modalBounds[1][0] ||
          mousePos[1] < modalBounds[0][1] ||
          mousePos[1] > modalBounds[1][1]
        ) {
          setActive(false);
          closeCallback?.();
        }
      };
      if (!options || !options.noOutsideClickClose)
        document.addEventListener("click", handleOutsideModalClick);

      return () => {
        document.removeEventListener("click", handleOutsideModalClick);
      };
    }
  }, [active, modalRef.current]);

  useEffect(() => {
    if (!children) setActive(false);
  }, [children]);

  return (
    <Fade duration={250}>
      <div className={`modal ${active ? "is-active" : ""}`}>
        <div className="modal-background"></div>
        <div className="modal-content">
          <div
            className="modal-content-wrapper"
            ref={modalRef}
            style={
              options && options.wide
                ? { maxWidth: "1200px" }
                : options && options.semiwide
                ? { maxWidth: "768px" }
                : null
            }
          >
            <button
              className={`modal-close ${
                options && options.pronouncedCloseButton ? "highlight" : ""
              }`}
              onClick={() => {
                setActive(false);
                if (closeCallback) closeCallback();
              }}
            ></button>
            {children}
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Modal;
